export enum eTransactionCategory {
  Refinance = 'refinance',
  Purchase = 'purchase',
}

export const DisplayTransactionCategory = {
  [eTransactionCategory.Refinance]: 'Refinance',
  [eTransactionCategory.Purchase]: 'Purchase',
};
